<template>
    <md-content class="card">
        <md-dialog-confirm :md-active.sync="confirmDeleteClientDialog.active"
                           :md-title="$t('dialog.confirm-delete.title')"
                           :md-confirm-text="$t('dialog.confirm-delete.yes')"
                           :md-cancel-text="$t('dialog.confirm-delete.no')"
                           @md-confirm="confirmDeleteClientDialog.action()" />
        <div class="md-header-section" v-if="showTab">
            <md-content class="md-layout  md-alignment-space-around-space-between" :md-elevation="8">
                <div class="md-layout-item md-header-bg">
                    <h1 class="md-header-title">{{ $t('views.orders.list.title') }}</h1>
                </div>
                <div class="md-flex-right-align">
                    <div class="md-search-btn" v-if="!searchExpand" @click="searchExpand = !searchExpand">
                        <md-icon>search</md-icon>
                    </div>
                    <adsign-filter v-if="searchExpand" v-model="filterValue" :filter-data-model="filterDataModel" class=""
                                   @search="searchTemplate()" />
                    <conditional-router-link to="/importOrders" v-if="hasAccess('PRIVILEGE_ORDER_IMPORT_FROM_FILE')">
                        <md-button class="md-header-btn" style="margin-right: 10px">{{ $t('views.orders.list.import') }}</md-button>
                    </conditional-router-link>
                    <md-button class="md-header-btn" style="margin-right: 10px;" @click="generateXls()"
                    title="Wygeneruj Excel z listą zleceń">
{{ $t('views.orders.list.export') }}
</md-button>
                    <conditional-router-link to="/campaign/create">
                        <md-button class="md-header-btn">{{ $t('views.orders.list.add') }}</md-button>
                    </conditional-router-link>
                </div>
            </md-content>
        </div>

        <md-table v-model="orders.content" :md-sort.sync="currentSort" :md-sort-order.sync="currentSortOrder"
                  :md-sort-fn="customSort" @md-selected="onSelectOrder" style="white-space: nowrap">
            <md-table-row slot="md-table-row" slot-scope="{ item, index }" class="md-accent"
                          @mouseover="currentHoverIndex = index"
                          @mouseleave="currentHoverIndex = null"
                          @dblclick="onSelect(item)"
                          :class="isSignedOrder(orders.content,index) ? 'signed-order': ''" 
                          md-selectable="multiple" md-auto-select>
                <md-table-cell :md-label="$t('views.orders.list.table.label.lp')">{{ getNo(index) }}</md-table-cell>
                <md-table-cell :md-label="$t('views.orders.list.table.label.createdAt')" md-sort-by="createdAt">
                    {{ item.createdAt | moment('L LT') }}
                </md-table-cell>
               <md-table-cell :md-label="$t('views.order.station.form.label.station')" md-sort-by="displayedStation">
                    {{ item.displayedStation }}
                </md-table-cell>
                <md-table-cell :md-label="$t('views.orders.list.table.label.orderNumber')" md-sort-by="orderNumber">
                    {{ item.orderNumber }}
                </md-table-cell>
                <md-table-cell v-if="!isArchive" :md-label="$t('views.orders.list.table.label.campaignName')" md-sort-by="campaignName">
                    {{ item.campaign.name }}
                </md-table-cell>
                <md-table-cell v-if="!isArchive" :md-label="$t('views.orders.list.table.label.clientName')"
                               md-sort-by="campaign.client.subject.name">
{{ item.campaign.client.name }}
                </md-table-cell>
                <md-table-cell :md-label="$t('views.orders.list.table.label.orderType')" md-sort-by="orderType">
                    {{ !isArchive ? item.orderType.name : item.orderType }}
                </md-table-cell>
                <md-table-cell :md-label="$t('views.orders.list.table.label.spotType')" md-sort-by="spotType">
                    {{ !isArchive ? item.spotType.name : item.spotType }}
                </md-table-cell>
                <md-table-cell :md-label="$t('views.orders.list.table.label.isConfirmed')" md-sort-by="confirmDate">
                    {{ (item.confirmDate != null && item.confirmedBy != null) ? $t('views.orders.list.table.label.confirmedYes'):$t('views.orders.list.table.label.confirmedNo') }}
                </md-table-cell>
                <md-table-cell v-if="!isArchive" :md-label="$t('views.orders.list.table.label.period')"
                               md-sort-by="campaign.validFrom">
                    {{ item.campaign.validFrom | moment('L') }} - {{ item.campaign.validTo | moment('L') }}
                </md-table-cell>
                <md-table-cell :md-label="$t('views.orders.list.table.label.budget')" md-sort-by="budget">
                  {{ item.budget != 0.1 && item.budget != 0.2 && item.budget != 0 ? formatLocaleNumber(parseFloat((item.budget)).toFixed(2)) : '' }}
                </md-table-cell>
                <md-table-cell :md-label="$t('views.orders.list.table.label.grp')" md-sort-by="grp">
                    {{ formatLocaleNumber(item.grp) }}
                </md-table-cell>
                <md-table-cell v-if="isArchive" :md-label="$t('views.orders.list.table.label.validFrom')" md-sort-by="validFrom">
                    {{ item.validFrom }}
                </md-table-cell>
                <md-table-cell :md-label="!isArchive ? $t('views.orders.list.table.label.status') : $t('views.orders.list.table.label.validTo')" :md-sort-by="!isArchive ? 'status' : 'validTo'">
                    {{ !isArchive ? $t(`views.order.status.${item.status}`) : item.validTo }}
                </md-table-cell>
                <div class="actions" v-if="currentHoverIndex == index" :style="{right:setActionsPosition}">
                  <md-button class="md-icon-button" @click="hideCopyOrderButtons()" v-if="(copyOrderButtons == true || copyOrderWithNewCampaign == true) && selectedOrderRow === item.id">
                      <md-tooltip md-direction="top">{{ $t('undo') }}</md-tooltip>
                      <md-icon>undo</md-icon>
                    </md-button>
                <md-field>
                  <div v-if="copyOrderWithNewCampaignButton == true && selectedOrderRow === item.id">
                    <md-input style="height: 35px; margin-top: -12px; width: 400px;" v-model="campaignName"
                              autocomplete="off" :placeholder="errorMassage ? $t('validation.required') : $t('views.orders.list.table.label.newCampaignName')" />
                  </div>
                </md-field>
                 <md-button class="md-icon-button" style="height: 35px; margin-top: 5px;" @click="copyOrderWithNewCampaign(item, campaignName)"
                 v-if="copyOrderButtons == true && copyOrderWithNewCampaignButton == true && selectedOrderRow == item.id">
                    <md-tooltip md-direction="top">{{ $t('send') }}</md-tooltip>
                    <md-icon>send</md-icon>
                </md-button>
                  <md-button class="md-icon-button" @click="synchronizeOrder(item.id)"
                  v-if="item.status === 'SENDING_ERROR' && copyOrderButtons == false && copyOrderWithNewCampaignButton == false || (selectedOrderRow != item.id && item.status === 'SENDING_ERROR')">
                    <md-tooltip md-direction="top">{{ $t('refresh') }}</md-tooltip>
                    <md-icon>refresh</md-icon>
                  </md-button>
                  <md-button class="md-icon-button"
                  v-if="hasAccess('PRIVILEGE_ORDER_CANCEL') && item.canDelete && checkUserType() && copyOrderButtons == false && copyOrderWithNewCampaignButton == false || (hasAccess('PRIVILEGE_ORDER_CANCEL') && selectedOrderRow != item.id && item.canDelete && checkUserType())" @click="cancelOrder(item.id)">
                    <md-tooltip md-direction="top">{{ $t('delete') }}</md-tooltip>
                    <md-icon>delete</md-icon>
                  </md-button>
                  <conditional-router-link :to="`/campaign/${item.campaign.id}/order/${item.id}`"
                                           v-if="item.status == 'CREATE' && copyOrderButtons == false && copyOrderWithNewCampaignButton == false || (selectedOrderRow != item.id && item.status == 'CREATE')">
                    <md-button class="md-icon-button">
                      <md-tooltip md-direction="top">{{ $t('edit') }}</md-tooltip>
                      <md-icon>description</md-icon>
                    </md-button>
                  </conditional-router-link>
                    <md-button class="md-icon-button" @click="showCopyOrderButtons(item.id)"
                    v-if="copyOrderButtons == false && copyOrderWithNewCampaignButton == false || selectedOrderRow != item.id">
                      <md-tooltip md-direction="top">{{ $t('copyAs') }}</md-tooltip>
                      <md-icon>content_copy</md-icon>
                    </md-button>
                    <md-button class="md-icon-button" @click="showCampaignTitleInput(item.id)" v-if="copyOrderButtons == true && copyOrderWithNewCampaignButton == false && selectedOrderRow == item.id">
                      <md-tooltip md-direction="top">{{ $t('copyOrderWithNewCampaign') }}</md-tooltip>
                      <md-icon>control_point_duplicate</md-icon>
                    </md-button>
                    <md-button class="md-icon-button" @click="copyOrder(item)" v-if="item.status == 'CREATE' && copyOrderButtons == true && copyOrderWithNewCampaignButton == false && selectedOrderRow == item.id">
                      <md-tooltip md-direction="top">{{ $t('copyOrderWithSameCampaign') }}</md-tooltip>
                      <md-icon>content_copy</md-icon>
                    </md-button>
                     <conditional-router-link :to="`/orders/${item.id}`" v-if="allowEditOrder(item.status) && copyOrderButtons == false && copyOrderWithNewCampaignButton == false && selectedOrderRow != item.id ">
                    <md-button class="md-icon-button">
                      <md-tooltip md-direction="top">{{ $t('edit') }}</md-tooltip>
                      <md-icon>description</md-icon>
                    </md-button>
                  </conditional-router-link>
                  <conditional-router-link :to="routeToPreview(item)" v-if="copyOrderButtons == false && copyOrderWithNewCampaignButton == false || selectedOrderRow != item.id">
                    <md-button class="md-icon-button" @click="setIsArchive()">
                      <md-tooltip md-direction="top">{{ $t('view') }}</md-tooltip>
                      <md-icon>search</md-icon>
                    </md-button>
                  </conditional-router-link>
                </div>
            </md-table-row>
            <md-table-empty-state v-if="!loading" class="md-layout-item md-size-100" :md-label="$t('dialog.noData')" />
            <Spiner :loading="loading" />
        </md-table>
        <div class="md-layout right">
            <paginator :page.sync="currentPage" :length="orders.totalElements || 0" :page-size.sync="pageSize"
                       @pageChange="loadOrders(currentPage, pageSize, sort, filterValue)" class="right" />
        </div>
    </md-content>
</template>

<script>
  import Vue from 'vue';
  import {ordersEndpoint, archivesEndpoint} from '@/services/adsign-backend/endpoints'
  import ConditionalRouterLink from '@/components/ConditionalRouterLink';
  import {FilterType} from '@/mixins/filterType';
  import sortSupport from '@/mixins/sortSupport';
  import Paginator from '@/components/Paginator';
  import AdsignFilter from '@/components/AdsignFilter';
  import Spiner from '@/components/Spiner'
  import { mapGetters } from "vuex";
  import store from '@/store'
  import i18n from '@/i18n';
  import {orderViewAccess} from '@/config/accessConfig';
  import {required} from 'vuelidate/lib/validators';
  import orderCommons from '@/mixins/orderCommons';
  import { PackageTypeShortName, OrderType } from '@/mixins/dictionariesConst';

  export default {
    name: 'OrdersList',
    mixins: [sortSupport, orderCommons],
    components: {Paginator, ConditionalRouterLink, AdsignFilter, Spiner},
    computed: {
      ...mapGetters("misc", ["currentSortList"]),
      ...mapGetters("misc", ["searcherFilterData"]),
      ...mapGetters('auth', ['hasAccess']),
      ...mapGetters('auth', ['userType']),

      setActionsPosition(){
        if(this.isArchive) return "0px";
        else return "78px";
      }

    },
    props: {
      showTab: {
        type: Boolean,
        default: true,
      },
      isArchive: {
        type: Boolean,
        default: false,
      },
      filterValueProp: {
        type: String,
        default: ''
      },
    },
    created(){
      if(this.currentSortList.sortBy == 'id'){
          this.currentSort = 'createdAt'
          this.currentSortOrder = 'desc'
          this.pageSize = this.currentSortList.pageSize
          this.filterValue = this.searcherFilterData.filter
          this.searchExpand = this.searcherFilterData.searchExpand
        }else{
          this.currentSort = this.currentSortList.sortBy
          this.currentSortOrder = this.currentSortList.sortOrder
          this.pageSize = this.currentSortList.pageSize
          this.filterValue = this.searcherFilterData.filter
          this.searchExpand = this.searcherFilterData.searchExpand
        }
    },
    data: () => ({
      allowEditOrderStatusList: ['APPROVED_CREATE', 'APPROVED_UPDATE', 'GENERATE_CONTRACT', 'SIGN_CONFIRMED', 'UPDATED_PROVYS', 'CREATE_REJECTED',
        'PRODUCT_REJECTED', 'SENDING_ERROR', 'CANCEL_REJECT', 'UPDATE_REJECTED'],
      confirmDeleteClientDialog: {
        active: false,
        action: undefined
      },
      campaignName: null,
      errorMassage: false,
      selectedOrderRow: null,
      copyOrderButtons: false,
      copyOrderWithNewCampaignButton: false,
      searchExpand: false,
      currentSort: 'id',
      currentSortOrder: 'desc',
      orders: {
        pageable: {
          pageNumber: 0,
          pageSize: 0,
          filter: null
        },
        totalElements: null,
        content: []
      },
      filterValue: '',
      filterDataModel: [
        {id: 'orderNumber', type: FilterType.String},
        {id: 'campaignName', type: FilterType.String},
        {id: 'orderType', type: FilterType.String},
        {id: 'campaign.client.subject.name', type: FilterType.String},
        {id: 'validFrom', type: FilterType.Date},
        {id: 'validTo', type: FilterType.Date},
        {id: 'createdAt', type: FilterType.Date},
        {id: 'spotType', type: FilterType.String},
        {id: 'budget', type: FilterType.Int},
        {id: 'grp', type: FilterType.Int},
        {id: 'status', type: FilterType.OrderStatus},
        {id: 'confirmDate', type: FilterType.Date},
        {id: 'confirmedBy', type: FilterType.String}
      ],
      filterDataModelForArchive: [
        {id: 'orderNumber', type: FilterType.String},
        {id: 'orderType', type: FilterType.String},
        {id: 'validFrom', type: FilterType.Date},
        {id: 'validTo', type: FilterType.Date},
        {id: 'spotType', type: FilterType.String},
        {id: 'budget', type: FilterType.Int},
        {id: 'grp', type: FilterType.Int},
      ],
      currentHoverIndex: null,
      loading: false,
      ids: [],
      filterValue: ''
    }),
    mounted() {
      if(this.isArchive){
        this.$watch(() => this.filterValueProp, (result) => {
          this.filterValue = result
          this.loadOrders(this.currentPage, this.pageSize, this.sort, result);
        })
      }

    },
    methods: {
      isSignedOrder(item,index){
      return item[index].status =='SIGN_CONFIRMED'
    },
      showCopyOrderButtons(id) {
        this.selectedOrderRow = id;
        this.copyOrderWithNewCampaignButton = false;
        this.copyOrderButtons = true;
      },
      hideCopyOrderButtons() {
        this.copyOrderButtons = false;
        this.copyOrderWithNewCampaignButton = false;
        this.campaignName = null;
        this.errorMassage = false;
        this.selectedOrderRow = null;
      },
      showCampaignTitleInput(id) {
        this.copyOrderWithNewCampaignButton = true;
        this.selectedOrderRow = id;
      },
      allowEditOrder(orderStatus) {
        return this.allowEditOrderStatusList.includes(orderStatus);
      },
      customSort(value) {
        this.searchTemplate();
        return value;
      },
      loadOrders(page, pageSize, sort, filter) {
        this.loading = true
        if(!this.isArchive){
        ordersEndpoint.getOrders(page - 1, pageSize, sort, filter)
            .then(result => {
              this.orders = result.data;
            })
            .catch(this.handleServerValidationError)
            .finally(() => this.loading = false, store.commit('misc/SORT_LIST', {sortBy: this.currentSort, sortOrder: this.currentSortOrder, pageSize: this.pageSize}))
        }else{
          archivesEndpoint.getArchiveOrdersList(page - 1, pageSize, sort, filter)
            .then(result => {
              this.orders = result.data;
              this.$emit('isContent', result.data.content.length);
            })
            .catch(this.handleServerValidationError)
            .finally(() => this.loading = false, this.$emit('setDataModel', this.filterDataModelForArchive))
        }
      },
      searchTemplate() {
        this.loadOrders(this.currentPage, this.pageSize, this.sort, this.filterValue);
      },
      onSelect(item){
        if(this.isArchive){
          store.commit('order/IS_ARCHIVE', true)
          this.$router.push(`archives/view/order/${item.id}`)
        }else{
          store.commit('order/IS_ARCHIVE', false)
          this.$router.push(`orders/view/${item.id}/preview`)
        }
      },
      routeToPreview(item){
        if (this.isArchive) {
          return `/archives/view/order/${item.id}`;
        } else {
          const accessibleView = Object.keys(orderViewAccess)
            .find(viewName => this.hasAccess(orderViewAccess[viewName])) || '';

          return `/orders/view/${item.id}/${accessibleView}`;
        }
      },
      copyOrder(order) {
        ordersEndpoint.copyOrder(order.id).then((response) => {
          this.order = response.data.order;
        }).finally(() => {
          this.loadOrders(this.currentPage, this.pageSize, this.sort, this.filterValue);
          this.copyOrderButtons = false;
          this.selectedOrderRow = null;
        })
      },
      copyOrderWithNewCampaign(order, name) {
        if (this.campaignName == null) {
          this.errorMassage = true;
        } else {
        ordersEndpoint.copyOrderWithNewCampaign(order.id, name).then((response) => {
          this.order = response.data.order;
        }).finally(() => {
          this.loadOrders(this.currentPage, this.pageSize, this.sort, this.filterValue);
          this.copyOrderButtons = false;
          this.copyOrderWithNewCampaignButton = false;
          this.campaignName = null;
          this.errorMassage = false;
          this.selectedOrderRow = null;
        })}
      },
      setIsArchive(){
        if(this.isArchive){
          store.commit('order/IS_ARCHIVE', true)
        }else{
          store.commit('order/IS_ARCHIVE', false)
        }
      },
      cancelOrder(orderId) {
        Vue.swal({
          title: i18n.t("views.orders.list.cancelOrder.title"),
          text: i18n.t("views.orders.list.cancelOrder.subtitle"),
          showCancelButton: true,
          confirmButtonColor: "#E51937",
          confirmButtonText: i18n.t("views.orders.list.cancelOrder.confirmButton"),
          cancelButtonText: i18n.t("views.orders.list.cancelOrder.cancelButton"),
        }).then((res) => {
          if(res.value)
            ordersEndpoint.cancelOrder(orderId).finally(() => {
              this.loadOrders(this.currentPage, this.pageSize, this.sort, this.filterValue);
            })
        })
        // ordersEndpoint.cancelOrder(orderId).
      },
      checkUserType(){
        if(this.userType === 'CLIENT_USER' || this.userType === 'CLIENT_ADMIN')
          return true
        return false
      },
      synchronizeOrder(id){
        ordersEndpoint.synchronizeOrder(id, false).then(() => {
                this.$router.go();
            });
      },
      generateXls(){
        this.filterValue = 'id=in=('+this.ids.join()+')'
        let sort = 'createdAt,desc'
        ordersEndpoint.getOrdersXls(sort,this.filterValue).then((response) => {
          const url = URL.createObjectURL(new Blob([response.data], {
            type: 'application/vnd.ms-excel'
          }))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', "orders.xls")
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          this.filterValue = ''
        })
    },
    onSelectOrder(items){
      this.ids = [];
      this.selected = items;

      if (items.length > 0) {
        items.forEach(item => {
          this.ids.push(item.id);
        })
      }
    }
  },
    validations: {
            form: {
                campaignName: {
                    required
                }
            }
        },
}
</script>

<style scoped lang="scss">
@import "../../../custom.scss";

::placeholder {
  color: blue;
  font-size: 1.5em;
}
.signed-order{
  background-color: $color-header-gray;
  color: white;
}

::v-deep{
  .md-table-cell-container {
      padding-left: 20px !important;
      padding-right: 15px !important;
    }
}
</style>
